import { MeasurementSystem } from '../types';
import { KWH_UNIT, SQUARE_FEET, SQUARE_METER } from './constants';
export function kwhPerArea(locale) {
    return locale.measurementSystem === MeasurementSystem.IMPERIAL
        ? `${KWH_UNIT}/${SQUARE_FEET}`
        : `${KWH_UNIT}/${SQUARE_METER}`;
}
export function perArea(value, locale) {
    return locale.measurementSystem === MeasurementSystem.IMPERIAL
        ? value / 10.7639
        : value;
}
